import getToken from './getToken';

export default state => Boolean(getToken(state)) === false;
